let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dRzJO")).then(() => parcelRequire('7oC7C'));